var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.572718 13.3777C1.18362 13.7577 2.55814 14.3278 4.00903 14.3278C6.68171 14.3278 7.55987 12.6176 7.52169 11.3254C7.48351 9.15915 5.53627 8.20903 3.51266 8.20903H2.32904V6.65083H3.51266C5.03991 6.65083 6.98715 5.85273 6.98715 4.0285C6.98715 2.77435 6.18535 1.71021 4.2381 1.71021C3.01631 1.71021 1.79452 2.24228 1.14544 2.73634L0.572718 1.21615C1.37452 0.608076 2.97813 0 4.6581 0C7.75078 0 9.1253 1.82423 9.1253 3.68646C9.1253 5.28266 8.13259 6.65083 6.26171 7.33492C8.17077 7.75297 9.73621 9.19715 9.73621 11.3634C9.73621 13.8337 7.78896 16 4.0472 16C2.29086 16 0.763624 15.4679 0 14.9359L0.572718 13.3777Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.4a0580ad531d6d94fb650c3077396891.svg";
export { ForwardRef as ReactComponent };